import classNames from 'classnames';
import { Panel } from 'components';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { DashboardSettingsContextProvider } from '../context/DashboardSettingsContext';
import DashboardGrid from '../dashboard-grid/DashboardGrid/DashboardGrid';
import './Dashboard.scss';

interface IDashboardProps {
  className?: string | object;
}

function Dashboard(props: IDashboardProps) {
  const { className } = props;

  const [t] = useTranslation();
  const classes = classNames('dashboard', className);

  return (
    <Panel className={classes}>
      <Helmet>
        <title>{t('Dashboard')}</title>
      </Helmet>
      <DashboardSettingsContextProvider>
        <DashboardGrid />
      </DashboardSettingsContextProvider>
    </Panel>
  );
}

export default Dashboard;
